export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/he-il.lyaml"));
at({});
};